import { connect } from 'react-redux'
import { compose } from 'redux'
import { printDataUpdateRequest, updateNewspaperSettings } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import {  NEWSPAPER_DATA } from '../../../constants/state'
import EditFlyer from '../present/EditFlyer'
import EditNewspaper from '../present/EditNewspaper'

const mapStateToProps = (state, ownProps) => ({
    newspaperData: getData(state, NEWSPAPER_DATA)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData) => {
        dispatch(updateNewspaperSettings(itemData))
        dispatch(printDataUpdateRequest())
    }
})

const EditNewspaperContainer = ({newspaperData, onUpdateItem, closePagePath, itemType}) => {
    if(!newspaperData) {
        return ''
    }

    return <EditNewspaper
        itemData={newspaperData}
        itemType={itemType}
        closePagePath={closePagePath}
        onUpdateItem={onUpdateItem}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditNewspaperContainer)